import { useEffect, useRef, useState } from "react";
import { useOutletContext } from 'react-router-dom';
import { Menu, MenuItem } from '@mui/material';
import http from "../../utils/http-common";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import UpDown from '../../assets/landing_page/Icons/collapse.png';
import TopDown from '../../assets/landing_page/Icons/expand.png';
import CriticalPath from '../../assets/landing_page/Icons/critical path.png';
import "./styles.css";
import CircularProgress from '@mui/material/CircularProgress';
export default function BaseLineView({ projectData, onProjectDataUpdate, planData, resourceOptions, setResourceOptions }) {  
  const userID = localStorage.getItem("user_id");
  const gantt = window.gantt;
  const container = useRef(null);
  const filterPopoverRef = useRef(null);
  const columnsPopoverRef = useRef(null);
  const taskInProgressRef = useRef(new Set());
  const baselinePopoverRef = useRef(null);
  const [chartHeight, setChartHeight] = useState(500);
  const [searchText, setSearchText] = useState("");
  const { drawerOpen } = useOutletContext();
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showCriticalPath, setShowCriticalPath] = useState(false);
  const [timeScaleAnchor, setTimeScaleAnchor] = useState(null);
  const [selectedScale, setSelectedScale] = useState("Days");
  const [activeButton, setActiveButton] = useState(null);
    const [selectedBaseline, setSelectedBaseline] = useState(null);
  const selectedBaselineRef = useRef(selectedBaseline);
  const [filters, setFilters] = useState({
    resource: '',
    priority: '',
    status: ''
  });
  const [taskData, setTaskData] = useState([]);

  const latestProjectDataRef = useRef([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const updateQueueRef = useRef([]);
  const updateTimerRef = useRef(null);


  useEffect(() => {
      latestProjectDataRef.current = projectData;
      
  }, [projectData]);
  const planID = localStorage.getItem('plan_id');  
    useEffect(() => {
    selectedBaselineRef.current = selectedBaseline;
  }, [selectedBaseline]);
useEffect(() => {
  const style = document.createElement('style');
  style.textContent = `
    .baseline-bar {
      z-index: 1;
      opacity: 0.5;
    }
    .baseline-bar:hover {
      opacity: 0.8;
    }
  `;
  document.head.appendChild(style);

  return () => {
    document.head.removeChild(style);
  };
}, []);
  useEffect(() => {
  // Clear the Gantt chart when the component first mounts
  clearGanttChart();
  
  // Optional: Return a cleanup function to clear the chart when unmounting
  return () => {
    clearGanttChart();
  };
}, []); // Empty dependency array means this runs once on mount

useEffect(() => {
  const planId = localStorage.getItem('plan_id');
  if (!planId) {
    console.error("Plan ID not found in local storage.");
    return;
  }

  const fetchDetails = async () => {
    try {
      const response = await http.post("master_service/plan_role/user/mapping/details", { plan_id: planId });
      if (response.data?.mappings?.length > 0) {
        const fetchedResources = response.data.mappings.map((item) => ({
          key: item.user?.user_name || item.user?.email || "",
          label: item.user?.user_name || item.user?.email || ""
        }));
        setResourceOptions(prevOptions => {
          const newOptions = [...fetchedResources];
          return JSON.stringify(prevOptions) !== JSON.stringify(newOptions) ? newOptions : prevOptions;
        });
        // Update selected resource if it exists in new options
        if (selectedResource) {
          const resourceExists = fetchedResources.some(r => r.key === selectedResource);
          if (!resourceExists) {
            setSelectedResource("");
          }
        }
      }
    } catch (error) {
      console.error("Error fetching resources:", error);
      if (error.response?.status === 404) {
        console.error("Error 404 : No resources found for this plan.");
        setResourceOptions([]);
      }
    }
  };

  fetchDetails();
}, [selectedResource]); // Add selectedResource as dependency
useEffect(() => {
  if (gantt && resourceOptions) {
    // Update the column configuration
    const columns = gantt.config.columns;
    const resourceColumn = columns.find(col => col.name === "resource");
    if (resourceColumn) {
      resourceColumn.options = resourceOptions;
    }
    // Force refresh of the grid
    gantt.refreshData();
  }
}, [resourceOptions]);
  useEffect(() => {
    const handleGlobalMouseMove = (e) => {
      if (gantt.ext && gantt.ext.tooltip) {
        gantt.ext.tooltip.hide();
      }
    };

    const handleGlobalClick = (e) => {
      if (gantt.ext && gantt.ext.tooltip) {
        gantt.ext.tooltip.hide();
      }
    };

    // Add event listeners
    document.addEventListener('mousemove', handleGlobalMouseMove);
    document.addEventListener('click', handleGlobalClick);
    window.addEventListener('popstate', handleGlobalClick);

    // Cleanup function
    return () => {
      document.removeEventListener('mousemove', handleGlobalMouseMove);
      document.removeEventListener('click', handleGlobalClick);
      window.removeEventListener('popstate', handleGlobalClick);

      // Force cleanup of tooltip and gantt extensions
      if (gantt.ext && gantt.ext.tooltip) {
        gantt.ext.tooltip.hide();
        gantt.ext.tooltip = null;
      }

      // Clear any remaining tooltips from the DOM
      const tooltips = document.querySelectorAll('.gantt-tooltip');
      tooltips.forEach(tooltip => tooltip.remove());
    };
  }, []);
useEffect(() => {
    if (!projectData || projectData.length === 0) {
      gantt.clearAll();
      
      gantt.config.layout = {
        css: "gantt_container",
        rows: [
          {
            cols: [
              { view: "grid", scrollY: "scrollVer" },
              { resizer: true, width: 1 },
              { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
              { view: "scrollbar", id: "scrollVer" }
            ]
          },
          { view: "scrollbar", id: "scrollHor", height: 20 }
        ]
      };

      gantt.config.scroll_size = 18;
      gantt.config.show_task_cells = true;
      gantt.config.smart_rendering = true;
      gantt.config.min_column_width = 40;
      gantt.config.scale_height = 60;
      gantt.config.row_height = 40;
      gantt.config.readonly = isReadOnlyCheck;

      gantt.parse({
        data: [{
          id: 1,
          text: "",
          start_date: new Date(),
          duration: 1,
          progress: 0,
          open: true
        }],
        links: []
      });

      gantt.render();
    }
}, [projectData]);

  const [isReadOnly, setIsReadOnly] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const debounceTimers = new Map();
  const clearGanttChart = async () => {
  // Clear any tasks in progress
  taskInProgressRef.current.clear();
  
  // Clear any pending debounce timers
  debounceTimers.forEach((timer, key) => {
    clearTimeout(timer);
    debounceTimers.delete(key);
  });
  
  // Reset state variables
  setSearchText("");
  setSelectedResource("");
  setSelectedPriority("");
  setSelectedStatus("");
  setShowCriticalPath(false);
  setFilters({
    resource: '',
    priority: '',
    status: ''
  });
  
  // Clear the Gantt chart
  gantt.clearAll();
  
  // Remove any markers
  gantt.deleteMarker && gantt.deleteMarker();
  
  // Reset the data
  gantt.parse({
    data: [],
    links: []
  });
  
  // Reset the latestProjectDataRef
  latestProjectDataRef.current = [];
  
  // Reset any custom styling or classes
  gantt.templates.task_class = function(start, end, task) {
    return "";
  };
  
  // Re-render the chart
  gantt.render();
  
  // Return a resolved promise to support async/await
  return Promise.resolve();
};  

  const getUniqueResources = () => {
    const resources = projectData
      .filter(task => task.ResourceAssignments)
      .map(task => task.ResourceAssignments)
      .filter(Boolean)
      .flatMap(assignment => {
        const matches = assignment.match(/resource=(.*?)(?=\s(?:start|$))/g) || [];
        return matches.map(match => match.replace('resource=', '').trim());
      });
    return [...new Set(resources)];
  };
  const getUniqueResources1 = () => {
    const resources = projectData
      .filter(task => task.ResourceAssignments)
      .map(task => task.ResourceAssignments)
      .filter(Boolean)
      .flatMap(assignment => {
        const matches = assignment.match(/resource=(.*?)(?=\s(?:start|$))/g) || [];
        return matches.map(match => match.replace('resource=', '').trim());
      });
    const unique = [...new Set(resources)];
    return unique.map(resource => ({ key: resource, label: resource }));
  };
  const parsedTasks = () => {
    const safeDate = date => (date && !isNaN(new Date(date)) ? new Date(date) : null);

    return projectData.map(task => ({
      ...task,
      start_date: safeDate(task.start_date),
      end_date: safeDate(task.end_date),
      BaselineStart: safeDate(task.BaselineStart),
      BaselineFinish: safeDate(task.BaselineFinish),
      baseline1Start: safeDate(task.Baseline1Start),
      baseline1Finish: safeDate(task.Baseline1Finish),
      baseline2Start: safeDate(task.Baseline2Start),
      baseline2Finish: safeDate(task.Baseline2Finish),
    })).filter(task => task.start_date && task.end_date);
  };
    useEffect(() => {
    if (!parsedTasks.length) return;

    gantt.clearAll();
    gantt.parse({ data: parsedTasks });
  }, [parsedTasks]);
  const hasParsedOnce = useRef(false);

  useEffect(() => {
    if (!parsedTasks.length || hasParsedOnce.current) return;

    gantt.clearAll();
    gantt.parse({ data: parsedTasks });
    hasParsedOnce.current = true;
  }, [parsedTasks]);

  useEffect(() => {
    const extractTaskIdFromParent = (parentStr) => {
      const match = parentStr?.match(/id=(\d+)/);
      return match ? parseInt(match[1], 10) + 1 : null;
    };

    const formatTasks = (tasks) =>
      tasks
        .map((task) => {
          if (!task.text?.trim()) return null;

          let resource = "";
          if (task.ResourceAssignments) {
            const matches = task.ResourceAssignments.match(/resource=(.*?)(?=\s(?:start|$))/g);
            if (matches) {
              resource = matches.map((m) => m.replace("resource=", "").trim()).join(", ");
            }
          }

          return {
            ...task,
            id: task.id + 1,
            text: task.text,
            start_date: formatDate(task.start_date),
            end_date: task.end_date ? formatDate(task.end_date) : null,
            duration: parseDuration(task.duration),
            resource: resource,
            priority: task.Priority || "[Priority value=0]",
            order: parseInt(task.order, 10) || 0,
            progress: parseFloat(task.progress) || 0,
            parent: typeof task.parent === "string" && task.parent.includes("id=")
              ? extractTaskIdFromParent(task.parent)
              : task.parent || "",
          };
        })
        .filter((t) => t !== null);

    const formatLinks = (tasks) =>
      tasks
        .flatMap((task) =>
          !task.Predecessors || task.Predecessors === "[]"
            ? []
            : parsePredecessorsToLinks(task.Predecessors, task.id)
        )
        .filter(Boolean);

    if (searchText.trim() === "") {
      const tasks = {
        data: formatTasks(projectData),
        links: formatLinks(projectData),
      };
      gantt.clearAll();
      gantt.parse(tasks);
      return;
    }

    const searchLower = searchText.toLowerCase();

    // Step 1: Find all matching tasks
    const matchedTasks = projectData.filter((task) => {
      const nameMatch = task.text?.toLowerCase().includes(searchLower);
      const resourceMatch = task.ResourceAssignments?.toLowerCase().includes(searchLower);
      const priorityMatch = task.Priority?.toLowerCase().includes(searchLower);

      let status = "";
      const progress = parseFloat(task.progress) || 0;
      if (progress >= 100) status = "completed";
      else if (progress > 0) status = "in progress";
      else status = "not started";

      const statusMatch = status.includes(searchLower);

      return nameMatch || resourceMatch || priorityMatch || statusMatch;
    });

    // Step 2: Add parent tasks of matched tasks
    const matchedTaskIds = new Set(matchedTasks.map((t) => t.id));
    const parentTasks = [];

    matchedTasks.forEach((task) => {
      const parentStr = task.parent;
      if (parentStr?.includes("id=")) {
        const parentId = extractTaskIdFromParent(parentStr);
        const parentTask = projectData.find((t) => t.id + 1 === parentId);
        if (parentTask && !matchedTaskIds.has(parentTask.id)) {
          parentTasks.push(parentTask);
          matchedTaskIds.add(parentTask.id); // Avoid duplicates
        }
      }
    });

    const allFilteredTasks = [...matchedTasks, ...parentTasks];

    const filteredData = {
      data: formatTasks(allFilteredTasks),
      links: formatLinks(projectData),
    };
    gantt.clearAll();
    gantt.parse(filteredData);
    gantt.render();
  }, [searchText, projectData]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close filter popover if click is outside
      if (filterPopoverRef.current && !filterPopoverRef.current.contains(event.target)) {
        setAnchorEl(null);
      }

      // Close columns popover if click is outside
      if (columnsPopoverRef.current && !columnsPopoverRef.current.contains(event.target)) {
        setColumnsAnchorEl(null);
      }
      if (baselinePopoverRef.current && !baselinePopoverRef.current.contains(event.target)) {
        setBaselineAnchorEl(null);
      }

    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleExpandAll = () => {
    expandAll();
    setActiveButton('expand');
  };

  const handleCollapseAll = () => {
    collapseAll();
    setActiveButton('collapse');
  };
  const expandAll = () => {
    gantt.eachTask(function (task) {
      task.$open = true;
    });
    gantt.render();
  };

  const collapseAll = () => {
    // First pass: identify root tasks and their direct children
    const rootTasks = new Set();
    const childTasks = new Set();

    gantt.eachTask(task => {
      if (!task.parent) {
        rootTasks.add(task.id);
      } else {
        childTasks.add(task.id);
        // Get the ultimate parent of this task
        let currentTask = task;
        while (currentTask.parent) {
          currentTask = gantt.getTask(currentTask.parent);
        }
        rootTasks.add(currentTask.id);
      }
    });

    // Second pass: collapse all tasks according to hierarchy
    gantt.eachTask(task => {
      if (rootTasks.has(task.id)) {
        // Keep root level tasks expanded
        task.$open = false;
      } else if (childTasks.has(task.id)) {
        // Collapse all child tasks
        task.$open = false;
      }
    });

    gantt.render();
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const FilterPopover = ({ anchorEl, onClose, selectedResource, setSelectedResource, selectedPriority, setSelectedPriority, selectedStatus, setSelectedStatus, resources }) => {
    if (!anchorEl) return null;
    const rect = anchorEl.getBoundingClientRect();
    const handleApplyFilters = () => {
      const extractTaskIdFromParent = (parentStr) => {
        const match = parentStr?.match(/id=(\d+)/);
        return match ? parseInt(match[1], 10) + 1 : null;
      };

      const matchedTasks = projectData.filter(task => {
        // Resource filter
        const resourceMatch = !selectedResource || (
          task.ResourceAssignments &&
          task.ResourceAssignments.toLowerCase().includes(`resource=${selectedResource.toLowerCase()}`)
        );

        // Priority filter
        let taskPriority;
        const priorityValue = parseInt(task.Priority?.match(/value=(\d+)/)?.[1] || 0);
        if (priorityValue >= 1000) taskPriority = "high";
        else if (priorityValue > 0) taskPriority = "medium";
        else taskPriority = "low";
        const priorityMatch = !selectedPriority || taskPriority === selectedPriority;

        // Status filter
        let taskStatus;
        const progress = parseFloat(task.progress) || 0;
        if (progress >= 100) taskStatus = "completed";
        else if (progress > 0) taskStatus = "in-progress";
        else taskStatus = "not-started";
        const statusMatch = !selectedStatus || taskStatus === selectedStatus;

        return resourceMatch && priorityMatch && statusMatch;
      });

      // Add parent tasks of matched tasks
      const matchedTaskIds = new Set(matchedTasks.map((t) => t.id));
      const parentTasks = [];

      matchedTasks.forEach((task) => {
        const parentId = task.parent?.includes("id=") ? extractTaskIdFromParent(task.parent) : null;
        if (parentId) {
          const parentTask = projectData.find(t => t.id + 1 === parentId);
          if (parentTask && !matchedTaskIds.has(parentTask.id)) {
            parentTasks.push(parentTask);
            matchedTaskIds.add(parentTask.id);
          }
        }
      });

      const allFiltered = [...matchedTasks, ...parentTasks];

      const filteredData = {
        data: allFiltered
          .map(task => {
            if (!task.text || task.text.trim() === "") return null;

            // Extract resource
            let resource = "";
            if (task.ResourceAssignments) {
              const resourceMatches = task.ResourceAssignments.match(/resource=(.*?)(?=\s(?:start|$))/g);
              if (resourceMatches) {
                resource = resourceMatches
                  .map(match => match.replace('resource=', '').trim())
                  .join(', ');
              }
            }

            return {
              ...task,
              id: task.id + 1,
              start_date: formatDate(task.start_date),
              duration: parseDuration(task.duration),
              end_date: formatDate(task.duration),
              text: task.text,
              resource: resource,
              priority: task.Priority || "[Priority value=0]",
              order: parseInt(task.order, 10) || 0,
              progress: parseFloat(task.progress) || 0,
              parent: typeof task.parent === "string" && task.parent.includes("id=")
                ? extractTaskIdFromParent(task.parent)
                : task.parent || ""
            };
          })
          .filter(Boolean),
        links: projectData
          .flatMap(task => {
            if (!task.Predecessors || task.Predecessors === "[]") return [];
            const links = parsePredecessorsToLinks(task.Predecessors, task.id);
            return links || [];
          })
          .filter(Boolean)
      };

      gantt.clearAll();
      gantt.parse(filteredData);
      setFilters({
        resource: selectedResource,
        priority: selectedPriority,
        status: selectedStatus
      });
      onClose();
    };


    return (
      <div
        ref={filterPopoverRef}
        className="filter-popover"
        style={{
          position: 'absolute',
          top: 35,
          left: drawerOpen ? rect.left - 220 : rect.left - 100,
          fontFamily: 'Inter, sans-serif',
          fontSize: "12px",
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          borderRadius: '4px',
          padding: '6px',
          zIndex: 999,
          minWidth: '190px'
        }}
      >
        <div className="filter-section">
          <label>Resource</label>
          <select
            value={selectedResource}
            onChange={(e) => setSelectedResource(e.target.value)}
          >
            <option value="">Select Resources</option>
            {resources.map(resource => (
              <option key={resource} value={resource}>{resource}</option>
            ))}
          </select>
        </div>
        <div className="filter-section">
          <label>Priority</label>
          <select
            value={selectedPriority}
            onChange={(e) => setSelectedPriority(e.target.value)}
          >
            <option value="">All Priorities</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>
        <div className="filter-section">
          <label>Status</label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">All Statuses</option>
            <option value="not-started">Not Started</option>
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>
        </div>
        <button onClick={handleApplyFilters} style={{ backgroundColor: "#FF2800", color: 'white' }}>Apply</button>
      </div>
    );
  };
  const [columnsAnchorEl, setColumnsAnchorEl] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState({
    text: true,
    duration: true,
    start_date: true,
    end_date: true,
    priority: false,
    resource: false,
    progress: false,
    status: true,
  });
  // Add column visibility toggle handler
const handleColumnVisibilityChange = (columnName) => {
  setVisibleColumns(prev => ({
    ...prev,
    [columnName]: !prev[columnName]
  }));
};
  const ColumnsPopover = ({ anchorEl, onClose }) => {
    if (!anchorEl) return null;

    const handleColumnToggle = (columnName) => {
      setVisibleColumns(prev => {
        const newColumns = { ...prev, [columnName]: !prev[columnName] };
        // Update gantt columns while preserving the add column
        const currentColumns = [...gantt.config.columns];
        const addColumn = currentColumns.find(col => col.name === 'add'); // Find the add column

        // Update other columns visibility
        gantt.config.columns = currentColumns.map(col => {
          if (col.name === 'add') return col; // Don't modify add column
          return {
            ...col,
            hide: !newColumns[col.name]
          };
        });

        gantt.render();
        return newColumns;
      });
    };

    const columnLabels = {
      text: "Task Name",
      status: "Status",
      priority: "Priority",
      duration: "Duration",
      start_date: "Start Date",
      end_date: "End Date",
      progress: "Progress",
            ...(selectedBaseline && {
        [`${selectedBaseline}Start`]: `${selectedBaseline} Start`,
        [`${selectedBaseline}End`]: `${selectedBaseline} End`,
        [`${selectedBaseline}Duration`]: `${selectedBaseline} Duration`
      })
    };
    const rect = anchorEl.getBoundingClientRect();
    return (
      <div
        ref={columnsPopoverRef}
        className="columns-popover"
        style={{
          position: 'absolute',
          top: 35,
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          left: drawerOpen ? rect.left - 220 : rect.left - 80,
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          borderRadius: '4px',
          padding: '6px',
          zIndex: 999,
          minWidth: '95px'
        }}
      >
        {Object.entries(columnLabels).map(([key, label]) => (
          <div key={key} style={{ margin: '2px 0' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={visibleColumns[key]}
                onChange={() => handleColumnToggle(key)}
                style={{
                  minWidth: '15px',
                  margin: '2px',  // tighter spacing
                  accentColor: '#FF2800' // checkbox color
                }}
              />
              {label}
            </label>
          </div>
        ))}
      </div>

    );
  };
const [baselineAnchorEl, setBaselineAnchorEl] = useState(null);


  const BaselinePopover = ({ anchorEl, onClose }) => {
    const rect = anchorEl?.getBoundingClientRect();
    if (!anchorEl) return null;
    const handleBaselineSelect = (baselineType) => {
  setSelectedBaseline(baselineType);
  
  // Remove existing baseline layer if any
  if (gantt._baselineLayer) {
    gantt.removeTaskLayer(gantt._baselineLayer);
  }

  // Add new baseline layer
  gantt._baselineLayer = gantt.addTaskLayer((task) => {
    let start = null, end = null;

    switch (baselineType) {
      case 'baseline':
        start = task.BaselineStart ? new Date(task.BaselineStart) : null;
        end = task.BaselineFinish ? new Date(task.BaselineFinish) : null;
        break;
      case 'baseline1':
        start = task.Baseline1Start ? new Date(task.Baseline1Start) : null;
        end = task.Baseline1Finish ? new Date(task.Baseline1Finish) : null;
        break;
      case 'baseline2':
        start = task.Baseline2Start ? new Date(task.Baseline2Start) : null;
        end = task.Baseline2Finish ? new Date(task.Baseline2Finish) : null;
        break;
      default:
        return null;
    }

    if (!start || !end) return null;

    const sizes = gantt.getTaskPosition(task, start, end);
    if (!sizes) return null;

    const baselineEl = document.createElement('div');
    baselineEl.className = 'baseline-bar';
    baselineEl.style.cssText = `
      position: absolute;
      left: ${sizes.left}px;
      top: ${sizes.top + 37}px;
      width: ${sizes.width}px;
      height: 4px;
      background-color: rgb(8, 8, 8);
      border-radius: 2px;
      z-index: 1;
    `;

    return baselineEl;
  });

  // Add baseline columns
  const columns = [...gantt.config.columns];
  const baselineStartCol = {
    name: `${baselineType}Start`,
    label: `${baselineType} Start`,
    align: "center",
    width: 100,
    template: (task) => {
      const date = task[`${baselineType}Start`];
      return date ? gantt.date.date_to_str("%d-%m-%Y")(new Date(date)) : '';
    }
  };
  const baselineFinishCol = {
    name: `${baselineType}Finish`,
    label: `${baselineType} Finish`,
    align: "center",
    width: 100,
    template: (task) => {
      const date = task[`${baselineType}Finish`];
      return date ? gantt.date.date_to_str("%d-%m-%Y")(new Date(date)) : '';
    }
  };

  // Update columns configuration
  gantt.config.columns = [...columns, baselineStartCol, baselineFinishCol];
  
  // Refresh the chart
  gantt.render();
};

    const availableBaselines = projectData.reduce((types, task) => {
      if (task.BaselineStart) types.add('baseline');
      if (task.Baseline1Start) types.add('baseline1');
      if (task.Baseline2Start) types.add('baseline2');
      return types;
    }, new Set());

    return (
      <div
        ref={baselinePopoverRef}
        className="baseline-popover"
        style={{
          position: 'absolute',
          top: 35,
          left: drawerOpen ? rect.left - 230 : rect.left - 80,
          fontFamily: 'Inter, sans-serif',
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          borderRadius: '4px',
          padding: '8px',
          zIndex: 999,
          minWidth: '100px'
        }}
      >
        <div className="baseline-section" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {availableBaselines.has('baseline') && (
            <button
              onClick={() => handleBaselineSelect('baseline')}
              style={{
                padding: '6px 12px',
                textAlign: 'left',
                cursor: 'pointer'
              }}
            >
              Baseline
            </button>
          )}
          {availableBaselines.has('baseline1') && (
            <button
              onClick={() => handleBaselineSelect('baseline1')}
              style={{
                padding: '6px 12px',
                textAlign: 'left',
                backgroundColor: selectedBaseline === 'baseline1' ? '#e0e0e0' : 'transparent',
                border: '1px solid #ddd',
                cursor: 'pointer'
              }}
            >
              Baseline 1
            </button>
          )}
          {availableBaselines.has('baseline2') && (
            <button
              onClick={() => handleBaselineSelect('baseline2')}
              style={{
                padding: '6px 12px',
                textAlign: 'left',
                backgroundColor: selectedBaseline === 'baseline2' ? '#e0e0e0' : 'transparent',
                border: '1px solid #ddd',
                cursor: 'pointer'
              }}
            >
              Baseline 2
            </button>
          )}
        </div>
      </div>
    );
  };

  // Add this function to handle critical path toggle
  const toggleCriticalPath = () => {
    const show = !showCriticalPath;
    setShowCriticalPath(show);

    gantt.eachTask(task => {
      if (task.Critical?.toLowerCase() === "true") {
        gantt.getTask(task.id).$critical = show; // set a custom flag
      } else {
        gantt.getTask(task.id).$critical = false;
      }
    });

    gantt.templates.task_class = function (start, end, task) {
      if (task.$critical) return "critical-task";
      return "";
    };

    gantt.render();
  };


  // Function to calculate height dynamically based on task count
  function calculateDynamicHeight() {
    const taskCount = projectData.length;
    const minHeight = 250; // Minimum chart height in pixels
    const maxHeight = window.innerHeight * 0.8; // Max height as 80% of screen height
    const heightPerTask = 30; // Estimated height per task row

    return Math.min(maxHeight, Math.max(minHeight, taskCount * heightPerTask));
  }

  // Format ISO date to Gantt-compatible format (YYYY-MM-DD)
  const formatDate = (isoDate) => {
    if (!isoDate) return null;
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return null; // Check for invalid dates
    return date; // Return the date object directly
  };

  // Extract Task ID from parent string
  const extractTaskIdFromParent = (parentString) => {
    const match = parentString.match(/id=(\d+)/);
    return match ? parseInt(match[1], 10) + 1 : "";
  };

  // Parse duration from JSON data (e.g., "6.0d" → 6.0)
  const parseDuration = (duration) => {
    if (!duration) return 0;
    if (typeof duration === 'number') return Math.round(duration);
    // Extract number before 'd' and convert to float
    const numericValue = parseFloat(duration.replace?.('d', '') || duration);
    return isNaN(numericValue) ? 0 : Math.round(numericValue);
  };

  // Parse Predecessors to create links
  const parsePredecessorsToLinks = (predecessorString, taskId) => {
    const matches = predecessorString.match(/id=(\d+)/g);
    if (matches && matches.length === 2) {
      const predecessorTaskId = parseInt(matches[0].match(/\d+/)[0], 10) + 1;
      const dependentTaskId = parseInt(matches[1].match(/\d+/)[0], 10) + 1;
      return {
        id: `${taskId}-${dependentTaskId}`,
        source: predecessorTaskId,
        target: dependentTaskId,
        type: "0",
      };
    }
    return null;
  };
  const isReadOnlyCheck = planData?.user_id !== userID;
  useEffect(() => {
    const isReadOnlyCheck = planData?.user_id !== userID;
    // Handle resizing by recalculating chart height
    const handleResize = () => {
      setChartHeight(calculateDynamicHeight());
    };

    window.addEventListener("resize", handleResize);

    // Initialize plugins
    gantt.plugins({
      marker: true,
      tooltip: true,
      critical_path: true,
      zoom: true
    });
    // Configure tooltip behavior
    gantt.config.tooltip_timeout = 50;
    gantt.config.tooltip_hide_timeout = 0;
    gantt.config.tooltip_offset_x = 10;
    gantt.config.tooltip_offset_y = 20;

    // Add event listener to hide tooltip when mouse leaves GanttView
    const handleMouseLeave = () => {
      if (gantt.ext && gantt.ext.tooltip) {
        gantt.ext.tooltip.hide();
      }
    };

    if (container.current) {
      container.current.removeEventListener('mouseleave', handleMouseLeave);
      container.current.style.height = `${chartHeight}px`;
      container.current.style.overflow = 'auto';
      // Core configurations
      gantt.config = {
        ...gantt.config,
        readonly: isReadOnlyCheck,
        sort: true,
        //highlight_critical_path: true,
        show_tasks_outside_timescale: true,
        fit_tasks: true,
        show_markers: true, // Enable markers visibility
        // Disable all editing capabilities if read-only
        drag_move: !isReadOnlyCheck,
        drag_progress: !isReadOnlyCheck,
        drag_resize: !isReadOnlyCheck,
        drag_links: true,
        click_drag: !isReadOnlyCheck,
        drag_task: !isReadOnlyCheck
      };
      
      container.current.addEventListener('mouseleave', function () {
        if (gantt.ext && gantt.ext.tooltip) {
          gantt.ext.tooltip.hide();
        }
      });
      gantt.attachEvent("onLightbox", function(id) {
     setTimeout(() => {
    const labels = document.querySelectorAll(".gantt_section_label");
    labels.forEach((label, i) => {
      if (label.innerText === "undefined") {
        if (i === 0) label.innerText = "Task Description";
        if (i === 1) label.innerText = "Resource";
      }
    });
  }, 0);
});
      // Disable CRUD operations if readonly
      if (isReadOnlyCheck) {
        gantt.config.columns = gantt.config.columns.filter(col => col.name !== 'add');

        // Detach all editing events
        gantt.detachEvent("onTaskDblClick");
        gantt.detachEvent("onAfterTaskAdd");
        gantt.detachEvent("onAfterTaskUpdate");
        gantt.detachEvent("onAfterTaskDelete");
      } else {
         gantt.attachEvent("onAfterLinkAdd", (id, link) => {
          updateTaskRelations(link.source, link.target);
          return true;
        });

        gantt.attachEvent("onAfterLinkUpdate", (id, link) => {
          updateTaskRelations(link.source, link.target);
          return true;
        });

        const updateTaskRelations = (sourceId, targetId, linkId) => {
          const sourceTask = gantt.getTask(sourceId);
          const targetTask = gantt.getTask(targetId);

          if (!sourceTask || !targetTask) {
            console.warn("Source or target task not found.", { sourceTask, targetTask });
            return;
          }

          // 1. Get source task successors
          const sourceSuccessors = (sourceTask.$source || []).map(linkId => {
            const link = gantt.getLink(linkId);
            if (link) {
              const targetGanttId = link.target;
              const targetTaskObj = gantt.getTask(targetGanttId);
              return `Task id=${targetGanttId-1} uniqueID=${targetGanttId-1} name=${targetTaskObj ? targetTaskObj.text : 'Unknown Task'}`;
            }
            return null;
          }).filter(Boolean);

          // 2. Get target task predecessors
          const targetPredecessors = (targetTask.$target || []).map(linkId => {
            const link = gantt.getLink(linkId);
            if (link) {
              const sourceGanttId = link.source;
              const sourceTaskObj = gantt.getTask(sourceGanttId);
              return `Task id=${sourceGanttId-1} uniqueID=${sourceGanttId-1} name=${sourceTaskObj ? sourceTaskObj.text : 'Unknown Task'}`;
            }
            return null;
          }).filter(Boolean);

        };
      }
      // Update link configuration before gantt.init
      gantt.config.links = {
        finish_to_start: "0",
        start_to_start: "1",
        finish_to_finish: "2",
        start_to_finish: "3"
      };
      // Enable column resize and basic configs
      gantt.config.resize_columns = true;
      gantt.config.resize_rows = true;
      gantt.config.grid_resize = true;
      //gantt.config.grid_width = 250;
      gantt.config.grid_elastic_columns = true;
      gantt.config.keep_grid_width = true;

      // Enable readonly, sorting, and critical path
      gantt.config.readonly = isReadOnlyCheck;
      gantt.config.sort = true;
      //gantt.config.highlight_critical_path = true;
      gantt.config.show_tasks_outside_timescale = true;

      // Add zoom configuration
      const zoomConfig = {
        levels: [
          {
            name: "Days",
            scale_height: 60,
            min_column_width: 20,
            scales: [
              { unit: "month", step: 1, format: "%F %Y" },
              { unit: "day", step: 1, format: "%d" }
            ],
            min_duration: 30 * 24 * 60 * 60 * 1000, // Minimum 30 days in milliseconds
      render: "tree"
          },
          {
            name: "Weeks",
            scale_height: 60,
            min_column_width: 70,
            scales: [
              { unit: "month", step: 1, format: "%F %Y" },
              { unit: "week", step: 1, format: "Week #%W" }
            ],
      min_duration: 30 * 24 * 60 * 60 * 1000 // Minimum 30 days in milliseconds
          },
          {
            name: "Months",
            scale_height: 60,
            min_column_width: 70,
            scales: [
              { unit: "year", step: 1, format: "%Y" },
              { unit: "month", step: 1, format: "%M" }
            ],
      min_duration: 30 * 24 * 60 * 60 * 1000 // Minimum 30 days in milliseconds
          }
        ]
      };

      // Initialize zoom
      gantt.ext.zoom.init(zoomConfig);
      // Add zoom event handlers
      gantt.ext.zoom.setLevel("Days");
      gantt.ext.zoom.attachEvent("onAfterZoom", function (level, config) {
      });
      // Add zoom controls (optional - add these buttons in your UI)
      function zoomIn() {
        gantt.ext.zoom.zoomIn();
      }

      function zoomOut() {
        gantt.ext.zoom.zoomOut();
      }
      // Add today marker
      const today = new Date();
      gantt.addMarker({
        start_date: today,
        css: "today",
        text: "Today",
        title: "Today: " + gantt.date.date_to_str(gantt.config.task_date)(today)
      });

      gantt.templates.task_row_class = function (start, end, task) {
        return task.$index % 2 === 0 ? "odd-row" : "even-row";
      };

      gantt.templates.grid_row_class = function (start, end, task) {
        return task.$index % 2 === 0 ? "odd-row" : "even-row";
      };
      gantt.config.tooltip_timeout = 50;
      gantt.config.tooltip_hide_timeout = 0;
      gantt.config.tooltip_offset_x = 10;
      gantt.config.tooltip_offset_y = 20;
      // Add mouse leave event handler for the container
      container.current.addEventListener('mouseleave', function () {
        if (gantt.ext && gantt.ext.tooltip) {
          gantt.ext.tooltip.hide();
        }
      });

      // Enhanced tooltip configuration
      gantt.templates.tooltip_text = function (start, end, task) {
        if (!task || !container.current) return "";

        const rect = container.current.getBoundingClientRect();
        const mouseEvent = window.event;

        if (!mouseEvent) return "";

        const isInsideGantt =
          mouseEvent.clientX >= rect.left &&
          mouseEvent.clientX <= rect.right &&
          mouseEvent.clientY >= rect.top &&
          mouseEvent.clientY <= rect.bottom;

        if (!isInsideGantt) {
          return "";
        }
        const formatDate = gantt.date.date_to_str("%Y-%m-%d");
        const startDate = formatDate(start);
        const endDate = formatDate(end);
        const progressPercent = task.progress ? task.progress : 0;
        const constraintDate = task.ConstraintDate || "Not set";
        const constraintType = task.ConstraintType || "Not set";
        return `<div class="gantt-tooltip"> 
    <div class="tooltip-title" style="font-weight: bold; margin-bottom: 5px;">
      ${task.text || 'Untitled Task'}
    </div>
    <div class="tooltip-content">
      <div><strong>Start:</strong> ${startDate}</div>
      <div><strong>End:</strong> ${endDate}</div>
      <div><strong>Duration:</strong> ${task.duration || 0} ${(task.duration || 0) === 1 ? 'day' : 'days'}</div>
      <div><strong>Progress:</strong> ${progressPercent}%</div>
      ${task.resource ? `<div><strong>Resource:</strong> ${task.resource}</div>` : ''}
      <div><strong>Constraint Type:</strong> ${constraintType}</div>
      <div><strong>Constraint Date:</strong> ${constraintDate}</div>
    </div>
  </div>`;
      };
      // Add mouse move event handler for tooltip
      gantt.attachEvent("onGanttReady", function () {
        if (container.current) {
          container.current.addEventListener('mouseleave', function () {
            if (gantt.ext && gantt.ext.tooltip) {
              gantt.ext.tooltip.hide();
            }
          });
        }
      });

      gantt.attachEvent("onMouseMove", function (id, e) {
        if (!container.current || !gantt.ext || !gantt.ext.tooltip) return true;

        const rect = container.current.getBoundingClientRect();
        if (!rect) return true;

        const isOutside =
          e.clientX < rect.left ||
          e.clientX > rect.right ||
          e.clientY < rect.top ||
          e.clientY > rect.bottom;

        if (isOutside && gantt.ext.tooltip) {
          gantt.ext.tooltip.hide();
        }
        return true;
      });
      gantt.config.header_height = 50; // Adjust header height as needed
      gantt.config.grid_header_class = 'sticky-header';
      gantt.config.scale_height = 50;
      // Add tooltip configuration
      //gantt.config.tooltip_timeout = 50;
      gantt.config.tooltip_hide_timeout = 0;
      gantt.config.tooltip_offset_x = 10;
      gantt.config.tooltip_offset_y = 20;


      // Add baseline layer using layers API
      gantt.config.task_height = 12;
      gantt.config.row_height = 20;



      // Enhanced task class template
      gantt.templates.task_class = function (start, end, task) {
        const classes = [];
 // ✅ Check for summary/parent task properly in v7+
  if (gantt.hasChild(task.id) || task.type === "project") {
    classes.push("summary-task");
  }
        if (task.progress === 0) {
          classes.push("not-started");
        } else if (task.progress > 0 && task.progress < 99) {
          classes.push("in-progress");
        } else if (task.progress === 100) {
          classes.push("completed-task");
        }

        if (showCriticalPath && task.Critical === "True") {
          classes.push("critical-task");
        }
        if (task.BaselineStart && task.BaselineFinish) classes.push("has-baseline");
        return classes.join(" ");
      };

      gantt.config.columns = [
        {
          name: "text",
          label: "Task name",
          align: "left",
          tree: true,
          width: 200, // Flexible width
          resize: true,
          min_width: 100,
          max_width: 1000,
        },
        ...(visibleColumns.duration ? [{
          name: "duration",
          label: "Duration",
          align: "left",
          width: 80,
          resize: true,
          min_width: 60,
          max_width: 400,
          template: function (task) {
            const duration = parseInt(task.duration);
            return `${duration} ${duration === 1 ? 'day' : 'days'}`;
          },
        }] : []),
  ...(visibleColumns.start_date ? [{
          name: "start_date",
          label: "Start time",
          align: "left",
          width: 85,
          resize: true,
          min_width: 65,
          max_width: 400,
        }] : []),
  ...(visibleColumns.end_date ? [{
          name: "end_date",
          label: "End time",
          align: "left",
          width: 85,
          resize: true,
          min_width: 65,
          max_width: 400,
        }] : []),
        ...(visibleColumns.progress ? [{
          name: "progress",
          label: "Progress",
          align: "left",
          width: 80,
          resize: true,
          min_width: 60,
          max_width: 400,
          template: function (task) {
            if (task.progress >= 1) return task.progress + "%";
            return task.progress + "%";
          },
        }] : []),
  ...(visibleColumns.resource ? [{
          name: "resource",
          label: "Resource",
          align: "left",
          width: 100,
          resize: true,
          min_width: 80,
          max_width: 600,
      template: function(task) {
      const match = resourceOptions.find(opt => opt.key === task.resource);
      return match ? match.label : "";
    }    
        }] : []),
  ...(visibleColumns.priority ? [{
          name: "priority",
          label: "Priority",
          align: "left",
          width: 80,
          resize: true,
          min_width: 70,
          max_width: 400,
          template: function (task) {
            let priority;
            let color;
            const priorityValue = parseInt(task.Priority?.match(/value=(\d+)/)?.[1] || 0);

            if (priorityValue >= 1000) {
              priority = "High";
              color = "#f44336"; // Red
            } else if (priorityValue > 0) {
              priority = "Medium";
              color = "#2196f3"; // Blue
            } else {
              priority = "Low";
              color = "#4caf50"; // Green
            }

            return `<div class="task-priority ${priority.toLowerCase()}" 
      style="font-weight: bold; border: 1px solid ${color}; color: ${color}; border-radius: 20px;padding: 1px 6px; line-height: 1.2;">
      ${priority}</div>`;
          }}] : []),
          ...(visibleColumns.status ? [{
          name: "status",
          label: "Status",
          align: "left",
          width: 90,
          resize: true,
          min_width: 70,
          max_width: 400,
          template: function (task) {
            let status;
            let color;
            const progress = task.progress;
            if (progress >= 100) {
              status = "Completed";
              color = "#4caf50"; // Green
            } else if (progress > 0) {
              status = "In Progress";
              color = "#2196f3"; // Blue
            } else {
              status = "Not Started";
              color = "#474747";
            }

            return `<div class="task-status ${status.toLowerCase().replace(/\s+/g, '-')}" 
      style="font-weight: bold; border: 1px solid ${color}; color: ${color}; border-radius: 20px; padding: 1px 6px; line-height: 1.2;">
      ${status}</div>`;
          }
        }] : []),
      ];
gantt.config.grid_resize = true;
gantt.config.keep_grid_width = false;
      gantt.form_blocks["constraint_date"] = {
        render: function (sns) {
          return "<div class='gantt_cal_ltext'><input type='date' class='constraint-date-input'></div>";
        },
        set_value: function (node, value, task) {
          node.querySelector(".constraint-date-input").value = value || "";
        },
        get_value: function (node, task) {
          return node.querySelector(".constraint-date-input").value;
        }
      };
      gantt.locale.labels["section_resource"] = "Assigned To";
      gantt.config.lightbox.use_default_layout = true;
      // Add this to your task lightbox configuration
      gantt.config.lightbox.sections = [
        { name: "description", label: "Task Description", height: 38, map_to: "text", type: "textarea", focus: true },
        { 
     name: "resource",
     type: "select",
     map_to: "resource",
    options: resourceOptions,
  },
        { name: "time", label: "Time Period", height: 72, map_to: "auto", type: "duration" }
      ];
      gantt.config.fit_tasks = true;
      gantt.config.auto_scheduling = false;
      gantt.config.auto_scheduling_strict = false;
      gantt.config.auto_scheduling_compatibility = false;
      gantt.config.schedule_from_end = false;
      // Add resize events
      gantt.attachEvent("onBeforeColumnResize", function (ind, column) {
        return true;
      });
      gantt.attachEvent("onColumnResizeStart", function (ind, column) {
        gantt.$grid_resize = true;
        return true;
      });

      gantt.attachEvent(
        "onColumnResize",
        function (ind, column, old_width, new_width) {
          column.width = new_width;
          return true;
        }
      );

      gantt.attachEvent(
        "onColumnResizeEnd",
        function (ind, column, old_width, new_width) {
          column.width = new_width;
          gantt.render();
          return true;
        }
      );

      // Configure row height adjustment
      gantt.config.min_task_grid_row_height = 20; // Minimum row height during resize
      gantt.config.min_grid_column_width = 40;
      gantt.config.row_height = 25; // Default row height
      gantt.config.task_height = 30;
      // Enable row resize events
      gantt.attachEvent("onBeforeRowResize", function (id, task, node) {
        return true; // return false to prevent resize
      });

      gantt.attachEvent("onRowResize", function (id, task, height) {
        task.height = height;
        return true;
      });

      gantt.attachEvent("onAfterRowResize", function (id, task, height) {
        return true;
      });
      gantt.attachEvent("onTaskRowResize", function (id, task, height) {
        return true;
      });
      gantt.config.autosize = false;
      gantt.config.grid_resize = true;

      // Add custom CSS class for resize handles
      gantt.templates.grid_row_class = function (start, end, task) {
        return "grid-row-resize";
      };
      // Enhanced link styling
      gantt.templates.link_class = function (link) {
        return "gantt_link_" + link.type;
      };
      // Configure link appearance
      gantt.config.links = {
        finish_to_start: "0",
        start_to_start: "1",
        finish_to_finish: "2",
        start_to_finish: "3",
        color: "#ffa000",  // Changed to yellow/orange color
        width: 2
      };
      // Configure link appearance
      gantt.config.link_arrow_size = 6;
      gantt.config.link_line_width = 2;
      // Add custom link rendering
      gantt.templates.link_render = function (link) {
        const linkColor = "#ffa000";
        return {
          color: linkColor,
          width: 2,
          arrow: {
            width: 8,
            height: 8,
            color: linkColor
          }
        };
      };

      gantt.config.show_links = true;
      gantt.config.show_arrows = true;
      gantt.config.readonly = isReadOnlyCheck;
      gantt.config.drag_task = false; // Disable task dragging
      gantt.config.drag_links = true;
      gantt.templates.task_date = function (date) {
        return gantt.date.date_to_str(gantt.config.task_date)(date);
      };

      gantt.templates.timeline_cell_class = function (task, date) {
        return "no-recalc";
      };
      // Enable working time logic
      gantt.config.duration_unit = "day"; // Set duration unit to days
      gantt.config.work_time = false; // Enable working time settings
      gantt.config.min_duration = 0; // Allow zero duration tasks
      gantt.config.skip_off_time = false;
      gantt.config.duration_step = 1;
      gantt.templates.duration_text = function (start, end, task) {
        return task.duration;
      };
      // Optional: Highlight weekends on the chart
      gantt.templates.scale_cell_class = function (date) {
        if (date.getDay() === 6 || date.getDay() === 0) {
          return "weekend"; // Apply custom CSS class for weekends
        }
        return "";
      };

      gantt.templates.task_cell_class = function (item, date) {
        if (date.getDay() === 6 || date.getDay() === 0) {
          return "weekend";
        }
        return "";
      };
      gantt.config.round_dnd_dates = false;
      gantt.config.duration_round_unit = false;
      gantt.config.duration_unit = "day";
      gantt.config.calendar_time = false;
      gantt.config.correct_work_time = false;

      gantt.getDuration = function (start, end, task) {
        return task.duration;
      };
      gantt.templates.grid_header_class = function (columnName, column) {
        return "custom-grid-header";
      };
      gantt.templates.grid_row_class = function (start, end, task) {
        return "grid-row-resize";
      };
      gantt.config.scale_height = 40; // Increase header height

      gantt.config.scales = [
        { unit: "month", step: 1, format: "%F %Y" },
        { unit: "day", step: 1, format: "%d" },
      ];
      gantt.templates.task_cell_class = function (item, date) {
        return "chart-background";
      };
      gantt.templates.task_text = function (start, end, task) {
        const progressText = task.progress ? task.progress + "%" : "0%";
        let text = task.text;
        if (task.ConstraintType && task.ConstraintType !== "AS_SOON_AS_POSSIBLE") {
          text += ` [${task.ConstraintType}]`;
        }
        return `${task.text} (${progressText})`;
      };

      gantt.init(container.current);

      gantt.attachEvent("onBeforeTaskDisplay", function (id, task) {
        const { resource, priority, status } = filters;

        // Resource check
        const resourceMatch = !resource ||
          (task.ResourceAssignments && task.ResourceAssignments.toLowerCase().includes(`resource=${resource.toLowerCase()}`));

        // Priority check
        const priorityValue = parseInt(task.Priority?.match(/value=(\d+)/)?.[1] || 0);
        let taskPriority = "low";
        if (priorityValue >= 1000) taskPriority = "high";
        else if (priorityValue > 0) taskPriority = "medium";
        const priorityMatch = !priority || taskPriority === priority;

        // Status check
        const progress = parseFloat(task.progress) || 0;
        let taskStatus = "not-started";
        if (progress >= 100) taskStatus = "completed";
        else if (progress > 0) taskStatus = "in-progress";
        const statusMatch = !status || taskStatus === status;

        return resourceMatch && priorityMatch && statusMatch;
      });

      const tasks = {
        data: projectData
          .map((task) => {
            if (!task.text || task.text.trim() === "") {
              return null;
            }
            // Extract resource from ResourceAssignments
            let resource = "";
            if (task.ResourceAssignments) {
              const resourceMatches = task.ResourceAssignments.match(/resource=(.*?)(?=\s(?:start|$))/g);
              if (resourceMatches) {
                // Extract and clean up resource names, then join with comma
                resource = resourceMatches
                  .map(match => match.replace('resource=', '').trim())
                  .join(', ');
              }
            }
            const calculateWorkingDays = (startDate, endDate) => {
              let start = new Date(startDate);
              let end = new Date(endDate);
              let days = 0;

              while (start <= end) {
                // Skip weekends (6 = Saturday, 0 = Sunday)
                if (start.getDay() !== 6 && start.getDay() !== 0) {
                  days++;
                }
                start.setDate(start.getDate() + 1);
              }
              return days || 1; // Return at least 1 day
            };
            const cleanedTask = {
              ...task,
              id: task.id + 1,
              start_date: formatDate(task.start_date),
              duration: calculateWorkingDays(task.start_date, task.end_date),

              end_date: formatDate(task.end_date),
              text: task.text,
              resource: resource, // Add resource to task object
              priority: task.Priority || "[Priority value=0]",
              order: parseInt(task.order, 10) || 0,
              progress: parseFloat(task.progress) || 0,
              parent:
                typeof task.parent === "string" && task.parent.includes("id=")
                  ? extractTaskIdFromParent(task.parent)
                  : task.parent || "",
            };

            if (
              cleanedTask.id === undefined ||
              cleanedTask.id === cleanedTask.parent
            ) {
              console.error(
                "Invalid task ID or circular reference detected:",
                cleanedTask
              );
              return null;
            }
            return cleanedTask;
          })
          .filter((task) => task !== null),
        links: projectData
          .flatMap((task) => {
            if (!task.Predecessors || task.Predecessors === "[]") return [];
            const links = parsePredecessorsToLinks(task.Predecessors, task.id);
            return links || [];
          })
          .filter(Boolean)

      };
      setTaskData(tasks);
      gantt.parse(tasks);

      return () => {
        window.removeEventListener("resize", handleResize);
        gantt.clearAll();
      };
    }
  }, [isReadOnlyCheck, projectData, visibleColumns]);

  return (
    <div style={{ width: "100%", height: '500px', padding: '0px', margin: 0, position: 'relative' }}>
      <div style={{
        marginBottom: "6px",
        display: "flex",
        alignItems: "center",
        fontFamily: 'Inter, sans-serif',
        gap: "10px",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }}>
<div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <button onClick={handleExpandAll} style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '6px 8px', minWidth: 'auto', backgroundColor: activeButton === 'expand' ? '#add8e6' : 'initial' }}>
            <img src={TopDown} alt="Expand" style={{ width: '10px', height: '12px' }} />
            <span>Expand All</span>
          </button>

          <button onClick={handleCollapseAll} style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '6px 8px', backgroundColor: activeButton === 'collapse' ? '#add8e6' : 'initial', minWidth: 'auto' }}>
            <img src={UpDown} alt="Collapse" style={{ width: '10px', height: '12px' }} />
            <span>Collapse All</span>
          </button>

          <button onClick={toggleCriticalPath} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: '6px 12px',
            backgroundColor: showCriticalPath ? '#add8e6' : 'initial'
          }}>
            <img src={CriticalPath} alt="Critical Path" style={{ width: '16px', height: '16px' }} />
            <span>Critical Path</span>
          </button>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ddd",
          borderRadius: "4px",
          overflow: "hidden",
          backgroundColor: "white",
          padding: "6px 12px",
          marginLeft: "auto"
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "4px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "2px",
              cursor: "pointer"
            }}>
              {/* First dot for Days */}
              <div onClick={() => {
                gantt.ext.zoom.setLevel("Days");
                setSelectedScale("Days");
              }} style={{
                width: "8px",
                height: "8px",
                backgroundColor: selectedScale === "Days" ? "gray" : "lightgray",
                borderRadius: "50%",
                cursor: "pointer"
              }}></div>
              <div style={{
                width: "12px",
                height: "2px",
                backgroundColor: selectedScale === "Days" ? "gray" : "lightgray"
              }}></div>
              {/* Second dot for Weeks */}
              <div onClick={() => {
                gantt.ext.zoom.setLevel("Weeks");
                setSelectedScale("Weeks");
              }} style={{
                width: "8px",
                height: "8px",
                backgroundColor: selectedScale === "Weeks" ? "gray" : "lightgray",
                borderRadius: "50%",
                cursor: "pointer"
              }}></div>
              <div style={{
                width: "12px",
                height: "2px",
                backgroundColor: selectedScale === "Weeks" ? "gray" : "lightgray"
              }}></div>
              {/* Third dot for Months */}
              <div onClick={() => {
                gantt.ext.zoom.setLevel("Months");
                setSelectedScale("Months");
              }} style={{
                width: "8px",
                height: "8px",
                backgroundColor: selectedScale === "Months" ? "gray" : "lightgray",
                borderRadius: "50%",
                cursor: "pointer"
              }}></div>
            </div>
            <button
              onClick={(e) => setTimeScaleAnchor(e.currentTarget)}
              style={{
                border: "none",
                background: "none",
                padding: "0 4px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                color: "gray"
              }}
            >
              {selectedScale}
            </button>
          </div>
          <Menu
            anchorEl={timeScaleAnchor}
            open={Boolean(timeScaleAnchor)}
            onClose={() => setTimeScaleAnchor(null)}
          >
            <MenuItem onClick={() => {
              gantt.ext.zoom.setLevel("Days");
              setSelectedScale("Days");
              setTimeScaleAnchor(null);
            }}>Daily</MenuItem>
            <MenuItem onClick={() => {
              gantt.ext.zoom.setLevel("Weeks");
              setSelectedScale("Weeks");
              setTimeScaleAnchor(null);
            }}>Weekly</MenuItem>
            <MenuItem onClick={() => {
              gantt.ext.zoom.setLevel("Months");
              setSelectedScale("Months");
              setTimeScaleAnchor(null);
            }}>Monthly</MenuItem>
          </Menu>
        </div>
        {/* Search and Filters */}
        <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: "auto" }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            fontFamily: 'Inter, sans-serif',
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "2px 8px",
            backgroundColor: "white"
          }}>
            <SearchIcon style={{ color: '#666', fontSize: 20 }} />
            <input
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                padding: "5px",
                border: "none",
                outline: "none",
                marginLeft: "5px",
                width: "150px"
              }}
            />
          </div>
          <button
            onClick={(e) => {
              if (anchorEl) {
                setAnchorEl(null);
              } else {
                setAnchorEl(e.currentTarget);
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Inter, sans-serif',
              gap: '4px',
              padding: '4px 10px'
            }}
          >
            <span>Filters</span>
            <KeyboardArrowDownIcon style={{ fontSize: 20 }} />
          </button>
          <button
            onClick={(e) => {
              if (columnsAnchorEl) {
                setColumnsAnchorEl(null);
              } else {
                setColumnsAnchorEl(e.currentTarget);
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'Inter, sans-serif',
              gap: '4px',
              padding: '4px 10px'
            }}
          >
            <span>Columns</span>
            <KeyboardArrowDownIcon style={{ fontSize: 20 }} />
          </button>
                    <button
            onClick={(e) => {
              if (baselineAnchorEl) {
                setBaselineAnchorEl(null);
              } else {
                setBaselineAnchorEl(e.currentTarget);
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '4px 10px'
            }}
          >
            <span>Baseline</span>
            <KeyboardArrowDownIcon style={{ fontSize: 20 }} />
          </button>
        </div>
      </div>
      <FilterPopover
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        selectedResource={selectedResource}
        setSelectedResource={setSelectedResource}
        selectedPriority={selectedPriority}
        setSelectedPriority={setSelectedPriority}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        resources={getUniqueResources()}
      />
      <ColumnsPopover
        anchorEl={columnsAnchorEl}
        onClose={() => setColumnsAnchorEl(null)}
      />
            <BaselinePopover
        anchorEl={baselineAnchorEl}
        onClose={() => setBaselineAnchorEl(null)}
      />

      <div ref={container} style={{
        width: "100%",
        height: "800px", // Adjusted to account for header and controls
        display: 'flex'
      }}></div>
    </div>
  );
}
